import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RowndProvider } from '@rownd/react'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <RowndProvider
    appKey="key_atpmto19c9wl3nebjri1s0ag"
  >
    <StrictMode>
      <App />
    </StrictMode>
  </RowndProvider>,
)
